import React from 'react';
import LocationTemplate from './LocationTemplate';

const NashvillePage: React.FC = () => {
  return (
    <LocationTemplate
      cityName="Nashville"
      stateName="North Carolina"
      countyName="Nash"
      zipCodes={["27856"]}
      latitude={35.9743}
      longitude={-77.9647}
      population={5629}
      historicalFact="Established in 1815 and named for Revolutionary War General Francis Nash."
      nearbyTowns={[
        "Rocky Mount, NC",
        "Wilson, NC",
        "Tarboro, NC",
        "Spring Hope, NC",
        "Middlesex, NC",
        "Bailey, NC",
        "Red Oak, NC",
        "Castalia, NC"
      ]}
    />
  );
};

export default NashvillePage;